import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faLightbulb } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components/macro";

const InformationBubbleContainer = styled.span<{ fontSize: string }>(
  ({ theme: { colors, fontWeights, fontSizes, radii, space }, fontSize }) => `
  background-color: ${colors.surfaceBackground};
  border-radius: ${radii[4]}px;
  padding: ${space[1]}px;
  color: ${colors.titleMedium};
  font-weight:${fontWeights.normal};
  font-size:${fontSizes[fontSize]}px;
`,
);

export interface InformationBubbleProps {
  icon?: IconProp;
  message?: string;
  fontSize?: string;
}

export function InformationBubble(props: InformationBubbleProps) {
  const { icon = faLightbulb, message, fontSize = "alpha" } = props;
  return (
    <InformationBubbleContainer fontSize={fontSize}>
      {icon && (
        <>
          <FontAwesomeIcon icon={icon} />
          &nbsp;
        </>
      )}
      {message && <span>{message}</span>}
    </InformationBubbleContainer>
  );
}
